export default {
    getSystemAlertMessages: { method: 'get', url: 'emcadmin/alert-messages' },
    postSystemAlertMessages: { method: 'post', url: 'emcadmin/alert-messages' },
    putSystemAlertMessages: { method: 'put', url: 'emcadmin/alert-messages/{id}' },
    deleteSystemAlertMessages: { method: 'delete', url: 'emcadmin/alert-messages/{id}' },
}
